// config.ts
export const apiUrl = "https://api-booking.biarritz-thalasso.com";
